/**
 * 任务"正在跑"的状态集合。排队态（pending/draft/pending_normalization/
 * pending_pronoun_resolve）与瞬态 cancelling 刻意排除——呼吸动画只表达"正在运行"。
 * 供 StatusBadge 呼吸与 useStatusTransition 完成/失败翻转检测共用。
 */
export const PROCESSING_STATUSES: readonly string[] = [
  'generating',
  'generating_shots',
  'splitting',
  'uploading_to_tos',
  'downloading_episodes',
  'uploading_episodes_to_tos',
  'normalizing',
  'resolving_pronouns',
];

export function isProcessingStatus(status: string): boolean {
  return PROCESSING_STATUSES.includes(status);
}
